import React, { useState, useContext } from "react";
import axios from "axios";
import { AppContext } from "../Contexts/AppContext";
import Constants from "../Utilities/Constants";
import { usePageTitle } from "../Utilities/usePageTitle";

const ValueCard = () => {
    usePageTitle('כרטיס ערך');
    const [cardNumber, setCardNumber] = useState('');
    const [searchResult, setSearchResult] = useState(null);
    const [error, setError] = useState('');
    const { setCustomer } = useContext(AppContext);

    const handleRegisterCard = async () => {
        try {
            const response = await axios.post(Constants.API_URL_REGISTER_CARD, { cardNumber });
            setCustomer(response.data);
            alert("Card registered successfully!");
        } catch (err) {
            setError("Error registering card: " + (err.response ? err.response.data.message : err.message));
        }
    };

    const handleSearchCard = async () => {
        try {
            const response = await axios.get(`${Constants.API_URL_SEARCH_CARD}?cellPhone=${cardNumber}`,
                {
                    headers: {
                        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJDbGFpbVR5cGUiOiJQT1MiLCJWQ1Rva2VuIjoiNzk1RTE3NjcxMjIyNDc0REExN0QxQjc4Mzc5QTMwNTUiLCJMb2NhdGlvbklkIjoiMzU0ODUiLCJQb3NJZCI6IjcxMTc1IiwiUG9zUGFzc3dvcmQiOiIyMjUxODMiLCJDYXNoaWVyc1Bhc3N3b3JkIjoiNTEzODAxIiwibmJmIjoxNzM4ODI3NTE0LCJleHAiOjEwMzc4ODI3NTE0LCJpYXQiOjE3Mzg4Mjc1MTQsImF1ZCI6IlBPUyJ9.XPnnSI3Da1lj2v-Of1HZjyJ9Hkqv6hrxMXZPaxeqGLc'
                    }
                }
            );
            setSearchResult(response.data);
        } catch (err) {
            setError("Error searching card: " + (err.response ? err.response.data.message : err.message));
        }
    };

    return (
        <div className="container">
            <h2 className="m-5 text-center">Value Card Management</h2>
            <div className="wrapper d-flex justify-content-center align-items-center row m-auto">
                <input
                    type="text"
                    placeholder="Enter Card Number"
                    value={cardNumber}
                    onChange={(e) => setCardNumber(e.target.value)}
                />
                <button onClick={handleRegisterCard}>Register Card</button>
                <button onClick={handleSearchCard}>Search Card</button>
                {error && <div className="error">{error}</div>}
                {searchResult && <div className="result">{JSON.stringify(searchResult)}</div>}
            </div>
        </div>
    );
};

export default ValueCard;